// extracted by mini-css-extract-plugin
module.exports = {"page":"guides-hub_page__ezKO5","seoSection":"guides-hub_seoSection__bh9rq","fullWidthCta":"guides-hub_fullWidthCta__MLO5x"};